import { ABILITIES, can } from "./abilities";

/** Reads `isolate_members` from globalData (`globals.tenant_info.tenant_config`), same as other tenant config. */
const isIsolateMembersEnabledFromGlobals = (globals) => {
	const raw = globals?.tenant_info?.tenant_config?.isolate_members;
	if (raw === true || raw === 1 || raw === "1") return true;
	if (raw === false || raw === 0 || raw === "0") return false;
	return Boolean(raw);
};

/**
 * When tenant isolates members (globalData), hide Patients + Customize Cases for members only.
 * The Account Holder and Account Managers are unaffected.
 */
export const shouldRestrictIsolateMembers = (globals, user) => {
	if (!isIsolateMembersEnabledFromGlobals(globals)) return false;
	if (can(user, ABILITIES.manageAccount)) return false;
	return true;
};
